import React from 'react';
import { GtmComponent } from '../../../types/go-to-market';
import { caretRight } from '@harbor/elements/icons';
import { HbrIcon } from '@harbor/elements-react-standalone';
import { CARD_STYLES } from './ArchitectureDetailStyles';


const ArchitectureComponentCard: React.FC<{
  component: GtmComponent,
  hoveredComponent: GtmComponent['id'] | null,
  setHoveredComponent: (id: GtmComponent['id'] | null) => void
  pinnedComponent: GtmComponent['id'] | null,
  setPinnedComponent: (id: GtmComponent['id'] | null) => void,
}> = ({
  component,
  hoveredComponent,
  setHoveredComponent,
  pinnedComponent,
  setPinnedComponent
}) => {
  const pinned = pinnedComponent === component.id;
  const hovered = hoveredComponent === component.id;
  const hasFeatures = component.product_feature && component.product_feature.length > 0;

  const backgroundStyle = hovered
    ? 'bg-cisco-blue-10'
    : pinned
      ? 'bg-cisco-blue-10/50'
      : 'bg-gray-10';
  const borderStyle = pinned
    ? 'outline-cisco-blue-30'
    : hovered
      ? 'outline-cisco-blue-60'
      : 'outline-gray-20';
  const featureTextStyle = pinned || hovered
    ? 'text-orange-50'
    : 'text-gray-50';

  const handleMouseEnter = () => setHoveredComponent(component.id);
  const handleMouseLeave = () => setHoveredComponent(null);
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (pinned) {
      setPinnedComponent(null);
    } else {
      setPinnedComponent(component.id);
    }
  }

  return (
    <div
      key={component.id}
      className={`${CARD_STYLES} ${borderStyle} ${backgroundStyle}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {hasFeatures && (
        <div className={"absolute bottom-2 right-2 flex items-center text-center gap-[2px]"}>
          <div className={`text-xs font-semibold italic ${featureTextStyle} transition-colors duration-500`}>
            Features
          </div>
          <HbrIcon
            asset={caretRight}
            className={`${pinned ? 'rotate-90': ''} ${featureTextStyle} transition-all duration-500`}
          />
        </div>
      )}

      <div className="">
        <div className="font-semibold">
          {component.name}
        </div>
        <div className="text-sm leading-snug my-2">
          {component?.description && component.description !== ''
            ? component?.description
            : (<div className="italic text-gray-50">No description provided</div>)
          }
        </div>
      </div>
    </div>
  )
}

export default ArchitectureComponentCard;